export function isThisANumber(number){
  return !Number.isNaN(Number(number))
}

export default isThisANumber